module.exports = __webpack_public_path__ + "img/uy.18d151c.webp";